module.exports = __webpack_public_path__ + "img/shape3.2f8029ee.svg";